module.exports = __webpack_public_path__ + "media/images/flags/kz-afe26325e1efbea11cc4b75fff3c6c2a.svg";